'use client'

import { useState, useEffect } from "react"
import SearchBar from "@/features/jobs/SearchBar"
import { useSearchParams } from "next/navigation"
import { useHandleSearchFromSearchBar } from "@/features/search/useHandleSearchFromSearchBar"

type SearchHeaderProps = {
    aroeven: Aroeven
}

export default function SearchHeader({
    aroeven
}: SearchHeaderProps) {

    const searchParams = useSearchParams()
    
    const [search, setSearch] = useState(Object.fromEntries(new URLSearchParams(searchParams)))

    useEffect(() => {
        setSearch({
            //...search,
            ...Object.fromEntries(new URLSearchParams(searchParams))
        })
    }, [searchParams])

    const handleSearch = useHandleSearchFromSearchBar(search, 'search', 'object', 'Job')    

    return (
        <>
            <section className="navscroll d-none recherche pt-10 pb-0">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-xl-3 d-flex align-items-start" />
                        <div className="col-lg-12 col-xl-9">
                            <div className="tabs -underline">
                                <SearchBar
                                    search={search}
                                    setSearch={setSearch}
                                    handleSearch={handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="navhead recherche pt-40 pb-40 bg-bloc">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-xl-3 d-flex align-items-start" />
                        <div className="col-lg-12 col-xl-9">
                            <div className="tabs -underline mt-80">
                                <div className="d-flex flex-column flex-wrap x-gap-0 y-gap-20 align-items-center">
                                    <h2 className="text-primary-4 pb-0">Rejoindre le mouvement</h2>
                                    <h3>Trouver un emploi dans nos différents sites</h3>
                                </div>
                                <SearchBar
                                    search={search}
                                    setSearch={setSearch}
                                    handleSearch={handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}